import React, { useEffect, useState } from 'react';
import { AppShell } from '@/components/nav/AppShell';
import { paymentsApi, customersApi } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { fmtDate, fmtMoney } from '@/lib/format';
import { EmptyState } from '@/components/empty/EmptyState';
import { ListSkeleton } from '@/components/common/ListSkeleton';
import { CreditCard } from 'lucide-react';

export default function PaymentsPage() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [customers, setCustomers] = useState([]);

  useEffect(() => { (async () => {
    try {
      const [ps, cs] = await Promise.all([paymentsApi.list(), customersApi.list()]);
      setItems(ps); setCustomers(cs);
    } catch {
      // surfaced by the api response interceptor
    } finally {
      setLoaded(true);
    }
  })(); }, []);

  const total = items.reduce((s, p) => s + (p.amount || 0), 0);

  return (
    <AppShell title="Payments">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between [&>*:last-child]:w-full sm:[&>*:last-child]:w-auto">
        <div>
          <h1 className="font-display text-2xl md:text-3xl font-semibold">Payments</h1>
          <p className="text-sm text-muted-foreground">Recorded payments from your customers.</p>
        </div>
        <Card><CardContent className="p-4">
          <div className="text-xs uppercase tracking-wide text-muted-foreground">Total received</div>
          <div className="font-display text-2xl font-semibold tabular-nums">{fmtMoney(total)}</div>
        </CardContent></Card>
      </div>
      {!loaded ? (
        <ListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState icon={CreditCard} title="No payments recorded" description="When you record payments on invoices, they show here." />
      ) : (
        <Card><CardContent className="p-0">
          <div className="divide-y">
            {items.map(p => {
              const c = customers.find(x => x.id === p.customer_id);
              return (
                <div key={p.id} className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-4 py-3 transition-colors hover:bg-muted/40">
                  <div>
                    <div className="font-medium text-sm">{c?.name || '—'} • {p.method}</div>
                    <div className="text-xs text-muted-foreground">{fmtDate(p.created_at)}</div>
                  </div>
                  <div className="font-semibold tabular-nums">{fmtMoney(p.amount)}</div>
                </div>
              );
            })}
          </div>
        </CardContent></Card>
      )}
    </AppShell>
  );
}
